import React from "react";
import { Button, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { Success } from "./Success";

const AddColumnTable = ({
  initialData,
  newColumns,
  setNewColumns,
  handleRerun,
  handleSave,
  saveLoading,
  isSaveDisabled,
  setIsSaveDisabled,
  success,
  visible,
  setVisible,
  reRunLoading,
  isreRunDisabled
}) => {

  const handleAddColumn = (key) => {
    // const newData = { ...initialData };
    // newData[key].push("");
    // setSynonyms(newData);
    const newNewColumns = { ...newColumns };
    if (!newNewColumns[key]) {
      newNewColumns[key] = [];
    }
    newNewColumns[key].push("");
    setNewColumns(newNewColumns);
    setIsSaveDisabled(false);

  };

  const handleInputChange = (key, index, event, isNewColumn = false) => {
    if (isNewColumn) {
      const newNewColumns = { ...newColumns };
      newNewColumns[key][index] = event.target.value;
      setNewColumns(newNewColumns);
    }
  };

  const handleDeleteColumn = (key, index) => {
    // const newData = { ...initialData };
    // newData[key].splice(index, 1);
    // setSynonyms(newData);
    const newNewColumns = { ...newColumns };
    newNewColumns[key] = newNewColumns[key].filter((_, i) => i !== index);
    setNewColumns(newNewColumns);
    // Check if all new columns are deleted
    const hasNewColumns = Object.values(newNewColumns).some(columns => columns.length > 0);
    setIsSaveDisabled(!hasNewColumns);
  };

  return (
    <>
      <Row className="d-flex flex-row p-2 mt-5">
        
        <Col className="d-flex flex-row justify-content-end">
          <Row>

            <Col xs="auto">
              {/* {error && (
              <Error message={error.message} />
              )} */}
            {success && (
              <Success message={success} visible={visible} setVisible={setVisible} />
            )}
            </Col>


            <Col xs="auto">
              <Button
                 disabled={isreRunDisabled}
                onClick={handleRerun}
                className="btn-outline-steel-blue btn-light me-2 dropdown-custom-color"
              >

                {reRunLoading ? (
                    <>
                        <Spinner animation="border" size="sm" /> Saving...
                    </>
                ) : (
                  <>
                  <i className="fa fa-redo"></i> Re-run
                  </>
                )}

              </Button>
            </Col>

            <Col xs="auto">
              <Button
                disabled={isSaveDisabled }
                onClick={handleSave}
                className="btn-outline-steel-blue btn-light me-2 dropdown-custom-color"
              >
                
                {saveLoading ? (
                    <>
                        <Spinner animation="border" size="sm" /> Saving...
                    </>
                ) : (
                  <>
                  <i className="fas fa-save"></i>&nbsp;Save
                  </>
                )}


              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Table hover className="shadow-white">
        <thead className="thead-mapping-color">
          <tr>
            <th>Name</th>
            <th>Add Synonym</th>

            {Array.from(
              {
                length: Math.max(
                  ...Object.values(initialData).map((arr) => arr.length)
                ),
              },
              (_, i) => (
                <th key={i}>Synonym {i + 1}</th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {Object.entries(initialData).map(([key, values]) => (
            <tr key={key} className="mapping-table-tr">
              <td style={{ color: "black", fontWeight: "bold" }}>{key}</td>
              <td>
                <Button
                  className="plus_icon"
                  onClick={() => handleAddColumn(key)}
                >
                  <i className="fa fa-plus"></i>{" "}
                </Button>
              </td>
              {values.map((value, index) => (
                <td key={index}>{value}</td>
              ))}

              {newColumns[key] &&
                newColumns[key].map((value, index) => (
                  <td key={values.length + index}>
                    <Form.Control
                      type="text"
                      value={value}
                      onChange={(event) =>
                        handleInputChange(key, index, event, true)
                      }
                    />
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDeleteColumn(key, index)}
                      style={{ marginLeft: "5px", marginTop:"5px" }}
                    >
                      <i className="fa fa-trash"></i>{" "}
                    </Button>
                  </td>
                ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default AddColumnTable;
